import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { Carousel, Slide } from '@uhg-abyss/web/ui/Carousel';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import React, { useEffect, useState } from 'react';

import { useSnackcardViewAllCount } from '../../hooks/useSnackcardViewAllCount';
import { phoneOnly } from '../ConstantsStyles';
import { makeAllSlidesAriaHidden } from '../Utils/a11yUtils/a11yUtils';
import { EnhancedVirtualVisitCard } from './EnhancedVirtualVisitCard';
import {
  NoResultsFoundContainer,
  mixedResultCarouselStyle,
} from './ResultSection.style';

export const EnhancedVirtualResultSection = ({
  showCarouselInMobile = false,
  virtualCareProviders,
  virtualCareProviderCount,
}) => {
  const phoneScreen = useMediaQuery(phoneOnly);
  const [slidesPerView, setSlidesPerView] = useState(2);
  const [winWidth, setWinWidth] = useState(window.innerWidth);

  const { isExpandViewAllEnabled } = useSnackcardViewAllCount(
    virtualCareProviderCount
  );
  // Get all providers from all categories
  const allProviders =
    virtualCareProviders?.flatMap(
      (category) =>
        category.providers?.map((provider) => ({
          ...provider,
          serviceType: category.serviceType,
        })) || []
    ) || [];

  useEffect(() => {
    let windowWidth = window.innerWidth;
    function handleResize() {
      windowWidth = window.innerWidth;
      setWinWidth(windowWidth);
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    if (winWidth > 872) {
      if (winWidth > 872 && allProviders?.length >= 3) setSlidesPerView(2);
      else if (winWidth < 1250 && allProviders?.length === 2)
        setSlidesPerView(3);
      else if (winWidth < 1250 && allProviders?.length > 2) setSlidesPerView(2);
      else if (winWidth > 1250 && allProviders?.length >= 2)
        setSlidesPerView(3);
      else if (allProviders.length >= 1) setSlidesPerView(4);
    }
    if (winWidth < 872) setSlidesPerView(1);
    if (
      isExpandViewAllEnabled &&
      winWidth > 868 &&
      (allProviders?.length === 1 || allProviders?.length === 2)
    )
      setSlidesPerView(2);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [winWidth, isExpandViewAllEnabled, allProviders?.length]);

  const virtualCareCards = allProviders?.map((provider) => (
    <EnhancedVirtualVisitCard
      key={`${provider?.serviceType}-${provider?.providerName}`}
      provider={provider}
      serviceType={provider?.serviceType}
      virtualCareProviders={virtualCareProviders}
    />
  ));

  return (
    <React.Fragment>
      <Layout.Stack
        css={{
          marginBottom: '8px',
          width: '100%',
        }}
        grow
        space={0}
      >
        {Array.isArray(virtualCareProviders) &&
        virtualCareProviders?.length > 0 &&
        virtualCareProviderCount ? (
          showCarouselInMobile && phoneScreen ? (
            <Carousel
              css={{
                ...mixedResultCarouselStyle(
                  isExpandViewAllEnabled
                    ? allProviders?.length + 1
                    : allProviders?.length,
                  winWidth,
                  false,
                  isExpandViewAllEnabled
                ),
              }}
              label=""
              nextSlideOnClick={() => makeAllSlidesAriaHidden()}
              prevSlideOnClick={() => makeAllSlidesAriaHidden()}
              slideIndexOnClick={() => makeAllSlidesAriaHidden()}
              slides={virtualCareCards.map((slide, id) => (
                <Slide
                  css={{
                    'abyss-slide-container': {
                      marginLeft: 0,
                      background: 'transparent',
                    },
                  }}
                  key={id}
                >
                  <div css={{ padding: 0 }}>{slide}</div>
                </Slide>
              ))}
              slidesPerView={slidesPerView}
            />
          ) : (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '15px',
                alignItems: 'center',
                flexWrap: 'wrap',
                width: phoneScreen ? '100%' : '107%',
              }}
            >
              {virtualCareCards.slice(0, 3).map((slide) => slide)}
            </div>
          )
        ) : (
          <NoResultsFoundContainer>
            <Text>{'No Results Found'}</Text>
          </NoResultsFoundContainer>
        )}
      </Layout.Stack>
    </React.Fragment>
  );
};
